import { __rest } from "tslib";
import React from 'react';
import { AuthedRoute } from '@marvelapp/ballpark-application';
import { UnauthorizedAccess } from './ErrorPages';
export function PrivateRoute(_a) {
    var { hasPermission, errorComponent = UnauthorizedAccess } = _a, rest = __rest(_a, ["hasPermission", "errorComponent"]);
    if (hasPermission) {
        return React.createElement(AuthedRoute, Object.assign({}, rest));
    }
    return React.createElement(AuthedRoute, { component: errorComponent });
}
